export default defineAppConfig({
  ui: {
    colors: {
      primary: 'var(--primary)',
      neutral: 'neutral'
    },
    badge: {
      slots: {
        base: 'text-xs px-2 py-1 gap-1 rounded-3xl',
        leadingIcon: 'size-4',
        leadingAvatarSize: '3xs',
        trailingIcon: 'size-4'
      }
    },
    button: {
      slots: {
        base: 'font-bold rounded-3xl'
      },
      variants: {
        outline: {
          class: 'bg-transparent'
        }
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'text-inverted'
        },
        {
          color: 'neutral',
          variant: 'outline',
          class: 'bg-transparent ring-neutral-900/20 dark:ring-neutral-100/20'
        },
        {
          color: 'neutral',
          variant: 'ghost',
          class:
            'hover:bg-neutral-900/10 hover:dark:bg-neutral-100/10 active:bg-neutral-900/20 active:dark:bg-neutral-100/20'
        }
      ]
    },
    card: {
      slots: {
        root: 'rounded-3xl'
      }
    },
    dropdownMenu: {
      slots: {
        content:
          'rounded-3xl shadow-lg p-2 bg-elevated/80 backdrop-blur-xl ring-0'
      }
    },
    slideover: {
      slots: {
        overlay: 'bg-neutral-200/20 dark:bg-neutral-900/20',
        content:
          'rounded-3xl shadow-lg p-4 bg-neutral-100/80 dark:bg-neutral-800/80 backdrop-blur-xl'
      },
      variants: {
        side: {
          left: {
            content: 'left-2 top-2 bottom-2 origin-left max-w-[80%]'
          },
          right: {
            content: 'right-2 top-2 bottom-2 origin-right max-w-[80%]'
          },
          top: {
            content: 'left-2 right-2 top-2 origin-top'
          },
          bottom: {
            content: 'left-2 right-2 bottom-2 origin-bottom'
          }
        }
      }
    },
    checkbox: {
      slots: {
        base: 'rounded-3xl ring-neutral-700 dark:ring-neutral-300'
      }
    },
    drawer: {
      slots: {
        overlay: 'bg-neutral-200/40 dark:bg-neutral-900/40',
        content: 'bg-elevated/80 backdrop-blur-xl ring-0',
        container: 'rounded-3xl shadow-lg'
      },
      variants: {
        inset: {
          true: {
            content: 'rounded-3xl'
          }
        }
      },
      compoundVariants: [
        {
          direction: 'bottom',
          inset: true,
          class: { content: 'inset-x-2 bottom-2' }
        }
      ]
    },
    contextMenu: {
      slots: {
        content:
          'rounded-3xl shadow-lg bg-elevated/80 backdrop-blur-xl p-2 ring-0'
      }
    },
    input: {
      slots: {
        base: 'rounded-3xl bg-transparent'
      }
    },
    inputMenu: {
      slots: {
        base: 'rounded-3xl',
        tagsItem: 'rounded-3xl bg-primary text-inverted font-bold ring-none',
        tagsItemDelete: 'text-inverted'
      }
    },
    link: {
      variants: {
        outline: {
          class: 'bg-transparent'
        }
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'text-neutral-800'
        },
        {
          color: 'neutral',
          variant: 'ghost',
          class: 'text-primary dark:text-inverted'
        },
        {
          color: 'neutral',
          variant: 'outline',
          class: 'bg-none'
        }
      ]
    },
    modal: {
      slots: {
        overlay: 'bg-neutral-200/20 dark: bg-neutral-900/20',
        content:
          'rounded-3xl shadow-lg p-4 bg-neutral-100/60 dark:bg-neutral-800/60 backdrop-blur-xl'
      },
      variants: {
        fullscreen: {
          false: {
            content: 'rounded-3xl shadow-lg border-0 ring-0'
          }
        }
      }
    },
    pageCard: {
      slots: {
        root: 'rounded-3xl'
      }
    },
    select: {
      slots: {
        base: 'rounded-3xl'
      }
    },
    selectMenu: {
      slots: {
        base: 'rounded-3xl',
        tagsItem: 'rounded-3xl bg-primary dark:text-inverted font-bol',
        tagsItemDelete: 'text-inverted'
      }
    },
    textarea: {
      slots: {
        base: 'rounded-3xl bg-transparent'
      },
      variant: {
        outline: 'bg-transparent ring-neutral-900/20 dark:ring-neutral-100/20'
      }
    },
    popover: {
      slots: {
        content:
          'rounded-3xl shadow-lg p-4 bg-elevated/80 backdrop-blur-xl ring-0'
      }
    },
    tooltip: {
      slots: {
        content:
          'rounded-3xl shadow-lg p-4 bg-elevated/80 backdrop-blur-xl ring-0'
      }
    },
    separator: {
      variants: {
        color: {
          neutral: {
            border: 'border-muted'
          }
        }
      }
    },
    toast: {
      slots: {
        root: 'rounded-3xl shadow-lg p-4 bg-elevated/80 backdrop-blur-xl ring-0'
      }
    }
  }
})
